// extracted by mini-css-extract-plugin
module.exports = {"FooterContainer":"FooterWithCopyright_FooterContainer__kEGVh"};